export default __webpack_public_path__ + "static/shoppingCart-c18d4867a071003897399ea33387f520.svg";